export default {
  today: '28082015-153327-0316',
  tomorrow: '28082015-154055-0426',
  chooseDate: '21022019-105513-0022',
  january: '05092016-131050-6122',
  february: '05092016-131051-0148',
  march: '05092016-131053-3576',
  april: '05092016-131054-4886',
  may: '05092016-131054-5110',
  june: '05092016-131055-4319',
  july: '05092016-131056-9782',
  august: '05092016-131059-2817',
  september: '05092016-131058-7909',
  october: '05092016-131059-2633',
  november: '05092016-131100-9542',
  december: '05092016-131059-4003',
  januaryShort: '06092016-123742-8998',
  februaryShort: '06092016-123743-2149',
  marchShort: '06092016-123744-8123',
  aprilShort: '06092016-123746-0319',
  mayShort: '06092016-123801-0771',
  juneShort: '06092016-123806-8305',
  julyShort: '06092016-123810-1352',
  augustShort: '06092016-123825-7585',
  septemberShort: '06092016-123825-1480',
  octoberShort: '06092016-123825-2427',
  novemberShort: '06092016-123825-2718',
  decemberShort: '06092016-123825-8897',
  mondayShort2ch: '05092016-125423-4374',
  tuesdayShort2ch: '05092016-125424-8662',
  wednesdayShort2ch: '05092016-125424-3578',
  thursdayShort2ch: '05092016-125424-5165',
  fridayShort2ch: '05092016-125424-6493',
  saturdayShort2ch: '05092016-125425-7309',
  sundayShort2ch: '05092016-125525-1102'
};
